// /admin/queries — real route. Mirrors apps/web's app/admin/queries/page.tsx:
// fully self-contained 'use client' page (paginated/filterable query browser
// against GET /api/admin/queries, already ported in
// apps/server/src/routes/admin-analytics.ts), no route params,
// lazy-imported directly per the porting convention (route-helpers.tsx).
// Registered from routes/admin.tsx under the `_admin` guard
// (routes/guards.tsx).
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminQueriesPage = lazy(() => import('@/app/admin/queries/page'));

export const adminQueriesRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin/queries',
  component: AdminQueriesPage,
});
